<template>
  <va-create-layout>
    <keywords-form :title="title" :item="item"></keywords-form>
  </va-create-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
